// 权限设置
import req from './index'
// 获取当前用户信息
export const getUserInfo = (params) => {
  return req.get('api/admin.php?service=Admin.Limitation.GetUserList', params)
}

// 获取权限信息
export const getPurviewInfo = (params) => {
  return req.get('api/admin.php?service=Admin.Limitation.GetUserLimitation', params)
}
// 提交权限信息
export const setPurviewInfo = (params) => {
  return req.get('api/admin.php?service=Admin.Limitation.SetUserLimitation', params)
}


